import { user } from './index'

// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

function fetchUserInfo(option) {
  return user.post('info.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

export { fetchUserInfo }